var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_742",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 29.3333C7.26671 29.3333 6.63893 29.0722 6.11671 28.55C5.59449 28.0278 5.33337 27.4 5.33337 26.6667V5.33334C5.33337 4.6 5.59449 3.97223 6.11671 3.45001C6.63893 2.92778 7.26671 2.66667 8.00004 2.66667H18.6667L26.6667 10.6667V14.6667C26.1556 14.7778 25.6778 14.9556 25.2334 15.2C24.7889 15.4444 24.3778 15.7556 24 16.1333L16 24.1V29.3333H8.00004ZM18.6667 29.3333V25.2333L26.0334 17.9C26.2334 17.7 26.4556 17.5556 26.7 17.4667C26.9445 17.3778 27.1889 17.3333 27.4334 17.3333C27.7 17.3333 27.9556 17.3833 28.2 17.4833C28.4445 17.5833 28.6667 17.7333 28.8667 17.9333L30.1 19.1667C30.2778 19.3667 30.4167 19.5889 30.5167 19.8333C30.6167 20.0778 30.6667 20.3222 30.6667 20.5667C30.6667 20.8111 30.6223 21.0611 30.5334 21.3167C30.4445 21.5722 30.3 21.8 30.1 22L22.7667 29.3333H18.6667ZM27.4334 21.8667L28.6667 20.5667L27.4334 19.3333L26.1667 20.6L27.4334 21.8667ZM17.3334 12H24L17.3334 5.33334V12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDocument);
export default __webpack_public_path__ + "static/media/editDocument.1cafc0829d3009e30f12327dd2a4adf3.svg";
export { ForwardRef as ReactComponent };